import { PRODUCT_TYPE } from '../../constants';

const DEFAULT_FILTERS = {
  min: 1,
  max: 900000,
  filters: {
    recipient: [],
    category: [],
    occasion: [],
    brand: [],
    type: [PRODUCT_TYPE.giftCard],
  },
  // orderBy: PRODUCT_SORTING.Alphabetic.value,
};

export default DEFAULT_FILTERS;
